import { Typography } from "@mui/material";

const ProfileVersion = () => {
    return (
        <>
            <Typography
                textAlign='center'
                fontWeight={400}
                fontSize={{xs: 12, md: 16}}
                letterSpacing={0.5}
                color="#5E5959"
                pb={3}
            >
                {`${process.env.REACT_APP_ENV} v${process.env.REACT_APP_APP_VERSION}`}
            </Typography>
        </>
    );
}

export default ProfileVersion;